module.exports = __webpack_public_path__ + "img/About_fw_5.d1a5a506.png";